import React from "react";

function TablaNuevosIngresos() {
  return (
    <div className="tablaGrafica">
      <b>NUEVOS INGRESOS POR MES Y POR NIVEL EDUCATIVO</b>
      <table>
        <thead>
          <tr>
            <th>Año</th>
            <th>Mes</th>
            <th>Ingresos Por <br /> Mes 2024</th>
            <th>Descripcion Nivel Educativo</th>
            <th>Tipo de Empleado</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>2024</td>
            <td>enero</td>
            <td>118</td>
            <td>Educación Primaria</td>
            <td>Docente</td>
          </tr>
          <tr>
            <td>2024</td>
            <td>mayo</td>
            <td>81</td>
            <td>Educación Primaria</td>
            <td>Docente</td>
          </tr>
          <tr>
            <td>2024</td>
            <td>octubre</td>
            <td>66</td>
            <td>Educación Primaria</td>
            <td>Docente</td>
          </tr>
          <tr>
            <td>2024</td>
            <td>febrero</td>
            <td>49</td>
            <td>Educación Primaria</td>
            <td>Docente</td>
          </tr>
          <tr>
            <td>2024</td>
            <td>abril</td>
            <td>44</td>
            <td>Educación Básica Personal de Apoyo y Asistencia</td>
            <td>Administrativo</td>
          </tr>
          <tr>
            <td>2024</td>
            <td>agosto</td>
            <td>41</td>
            <td>Educación Básica Personal de Apoyo y Asistencia</td>
            <td>Administrativo</td>
          </tr>
          <tr>
            <td>2024</td>
            <td>mayo</td>
            <td>61</td>
            <td>Educación Secundaria General y Técnica</td>
            <td>Docente</td>
          </tr>
          <tr>
            <td>2024</td>
            <td>abril</td>
            <td>32</td>
            <td>Bachillerato/Telebachillerato</td>
            <td>Administrativo</td>
          </tr>
          <tr>
            <td>2024</td>
            <td>septiembre</td>
            <td>32</td>
            <td>Educación Telesecundaria</td>
            <td>Docente</td>
          </tr>
          <tr>
            <td>2024</td>
            <td>noviembre</td>
            <td>37</td>
            <td>En verificación</td>
            <td>Docente</td>
          </tr>
          <tr>
            <td>2024</td>
            <td>septiembre</td>
            <td>36</td>
            <td>Educación Preescolar</td>
            <td>Docente</td>
          </tr>
          <tr>
            <td>2024</td>
            <td>enero</td>
            <td>25</td>
            <td>Bachillerato/Telebachillerato</td>
            <td>Docente</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="2">
              <strong>Total</strong>
            </td>
            <td colSpan="3">
              <strong>1314</strong>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default TablaNuevosIngresos;
